// extracted by mini-css-extract-plugin
module.exports = {"cold_list":"cold_list-1XOidj86","cold_a":"cold_a-2jC4JM5R"};